import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  isFinalBuy?: boolean;
}
export function CTAButton({
  text = 'SÍ, QUIERO REINICIAR MI CORTISOL AHORA',
  className = '',
  isFinalBuy = false
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (isFinalBuy) {
      // Fire AddToCart event only on final purchase button
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'AddToCart');
      }
      // Redirect to Hotmart
      window.location.href = 'https://pay.hotmart.com/N105029690V?checkoutMode=10';
    } else {
      // Scroll to the pricing/checkout section
      const section = document.getElementById('comprar');
      if (section) {
        section.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <a href="#comprar" onClick={handleClick} className={`inline-flex items-center justify-center bg-green-600 hover:bg-green-700 text-white font-extrabold px-6 py-4 rounded-xl text-lg md:text-xl transition-all duration-300 shadow-[0_8px_20px_rgba(22,163,74,0.4)] transform hover:-translate-y-1 hover:shadow-[0_12px_25px_rgba(22,163,74,0.5)] active:translate-y-0 active:shadow-md text-center w-full md:w-auto ${className}`} data-id="element-18">
      {text}
      <ArrowRightIcon className="ml-2 h-6 w-6 animate-pulse" data-id="element-19" />
    </a>;
}